import BasicResource from '@/api/resource';

class EventTypesResource extends BasicResource {

    constructor () {
        super('config/event-types');
    }

    enable (ids) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/enable`,
            data: { event_type: ids },
        });
    }

    disable (ids) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/disable`,
            data: { event_type: ids },
        });
    }
}

export default new EventTypesResource;
